export default __webpack_public_path__ + "static/media/skirmishers_bolts.7a426084.jpg";